/* unplugin-vue-components disabled */import { render } from "./Authorization.vue?vue&type=template&id=388addac"
import script from "./Authorization.vue?vue&type=script&lang=js"
export * from "./Authorization.vue?vue&type=script&lang=js"

import "./Authorization.vue?vue&type=style&index=0&id=388addac&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__